<script lang="ts" setup>
import { useVModels } from "@vueuse/core";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  invalid: {
    type: Boolean,
    default: false,
  },
  autocomplete: {
    type: String,
    default: undefined,
  },
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  placeholder: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["update:modelValue"]);
const { modelValue: _modelValue } = useVModels(props, emit);
const id = useId();
</script>
<template>
  <div class="flex flex-col">
    <label class="mb-1" :for="id">
      {{ label }}<span v-if="required" class="text-red-500">*</span>
    </label>
    <InputText
      :id="id"
      :invalid="invalid"
      :autocomplete="autocomplete"
      v-model="_modelValue"
      :type="type"
      :placeholder="placeholder"
    />
    <Message v-show="!!error" size="small" severity="error" variant="simple">
      {{ error }}
    </Message>
  </div>
</template>
